<template>
  <!-- wangEditor 官网 https://www.wangeditor.com/doc/-->
  <div class="editor">
    <div id="editView" :style=editStyle></div>
  </div>
</template>

<script>
// 引入 wangEditor
import wangEditor from "wangeditor";

export default {
  components: {},
  props: {
    /*
     *@Author: czc
     *@Date: 2021-07-12 16:11:40
     *@Description: 编辑器禁用启用直接查看调用method中对应方法
     */
    /*
     *@Author: czc
     *@Date: 2021-06-07 17:03:14
     *@Description: 当编辑器内容变化时触发 将内容抛出
     */
    onDataChange: {
      type: Function,
      default: () => {
        return Promise.resolve();
      },
    },
    /*
     *@Author: czc
     *@Date: 2021-06-07 15:39:48
     *@Description: 父组件直接设置编辑区域内容(只接收富文本格式)
     */
    richtext: {
      type: String,
      default: "",
    },
    /*
     *@Author: czc
     *@Date: 2021-06-07 17:05:26
     *@Description: 抛出编辑器内容延迟时间 默认400ms
     */
    dataChangeTimeout: {
      type: Number,
      default: 400,
    },
    /*
     *@Author: czc
     *@Date: 2021-06-07 17:15:51
     *@Description: 自定义编辑器样式
     */
    editStyle: {
      type: String,
      default: "text-align: left;",
    },
    /*
     *@Author: czc
     *@Date: 2021-06-07 15:41:12
     *@Description: 编辑区域高度(维旺迪项目所需此功能弃用)
     */
    editHeight: {
      type: [Number, String],
      default: 500,
    },
    /*
     *@Author: czc
     *@Date: 2021-06-07 15:43:58
     *@Description: 编辑区域的层级
     */
    editIndex: {
      type: Number,
      default: 5,
    },
    /*
     *@Author: czc
     *@Date: 2021-06-07 15:47:32
     *@Description: placeholder提示文字
     */
    editPlaceholder: {
      type: String,
      default: "请输入..",
    },
    /*
     *@Author: czc
     *@Date: 2021-06-07 15:51:55
     *@Description: 取消或开启自动 focus
     */
    autoFocus: {
      type: Boolean,
      default: false,
    },
    /*
     *@Author: czc
     *@Date: 2021-06-07 16:33:36
     *@Description: 菜单栏与顺序 默认显示所有菜单
     */
    menus: {
      type: Array,
      default: () => {
        return [
          "head",
          "bold",
          "fontSize",
          "fontName",
          "italic",
          "underline",
          "strikeThrough",
          "indent",
          "lineHeight",
          "foreColor",
          "backColor",
          "link",
          "list",
          "todo",
          "justify",
          "quote",
          "emoticon",
          "image",
          "video",
          "table",
          "code",
          "splitLine",
          "undo",
          "redo",
        ];
      },
    },
    /*
     *@Author: czc
     *@Date: 2021-06-07 16:46:29
     *@Description: 可供选择的的字体颜色与背景颜色,默认无
     */
    colorArray: {
      type: Array,
      default: () => {
        return [
          "#303133",
          "#909399",
          "#2979ff",
          "#fa3534",
          "#19be6b",
          "#7B1EAA",
          "#C89F38",
          "#FFFF00",
          "#845a33",
          "#003472",
          "#f36838",
          "#bf242a",
          "#9d2933",
          "#193CBB",
          "#09965B",
          "#ffffff",
        ];
      },
    },
    /*
     *@Author: czc
     *@Date: 2021-06-07 16:58:44
     *@Description: 设置菜单栏提示为上标还是下标 默认为true 上标
     */
    menuTipsPosition: {
      type: Boolean,
      default: true,
    },
    /*
     *@Author: czc
     *@Date: 2021-07-12 14:10:13
     *@Description: 默认图片上传大小 默认5M
     */
    imgMaxSize: {
      type: Number,
      default: 10,
    },
    /*
     *@Author: czc
     *@Date: 2021-07-12 14:11:17
     *@Description: 默认限制上传图片的类型
     */
    imgDefaultType: {
      type: Array,
      default: () => {
        return ["jpg", "jpeg", "png", "gif", "bmp"];
      },
    },

    /*
     *@Author: czc
     *@Date: 2021-07-12 14:19:12
     *@Description: 默认每次可以上传的图片数量为1
     */
    imgMaxLength: {
      type: Number,
      default: 1,
    },
    /*
     *@Author: czc
     *@Date: 2021-07-12 13:55:28
     *@Description: 上述参数不满足需求时可以去官网查找并自定义参数传入
     */
    receiveConfig: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      editor: null, // 富文本对象
      editorData: "", // 富文本内容
    };
  },
  watch: {
    richtext(val) {
      if (this.editor.txt.html(val) != val) {
        this.editor.txt.html(val);
        console.log('richtext=',val)
      }
    }
  },
  created() {},
  mounted() {
    const then = this;
    const editor = new wangEditor(`#editView`);

    // 设置编辑区域高度(维旺迪项目因为客户要求弃用 修改方式写在css代码中)
    editor.config.height = then.editHeight;

    // 设置编辑区域的层级
    editor.config.zIndex = then.editIndex;

    // 设置placeholder提示文字
    editor.config.placeholder = then.editPlaceholder;

    // 设置取消或开启自动 focus
    editor.config.focus = then.autoFocus;

    // 设置需要的菜单栏与顺序 默认显示所有菜单
    editor.config.menus = then.menus;

    // 设置可供选择的的字体颜色与背景颜色
    editor.config.colors = then.colorArray;

    // 设置自定义表情库(此内容以下为demo)
    editor.config.emotions = [
      {
        title: "emoji", // tab 的标题
        type: "emoji", // 'emoji' / 'image'
        // emoji 表情，content 是一个数组即可
        content:
          "😀 😃 😄 😁 😆 😅 😂 😊 😇 🙂 🙃 😉 😓 😪 😴 🙄 🤔 😬 🤐".split(
            /\s/
          ),
      },
    ];

    // 设置菜单栏提示为上标还是下标
    editor.config.menuTooltipPosition = then.menuTipsPosition ? "up" : "down";

    // 设置抛出编辑器内容延迟时间
    editor.config.onchangeTimeout = then.dataChangeTimeout;

    /*
     *@Author: czc
     *@Date: 2021-06-07 15:50:19
     *@Description: 配置 onchange 回调函数，将数据同步到 vue 中
     */
    editor.config.onchange = (newHtml) => {
      then.editorData = newHtml;
      then.onDataChange(newHtml);
    };

    /*
     *@Author: czc
     *@Date: 2021-07-12 14:08:53
     *@Description: 限制上传图片的大小 默认5M
     */
    // editor.config.uploadImgMaxSize = then.imgMaxSize * 1024 * 1024;

    /*
     *@Author: czc
     *@Date: 2021-07-12 14:12:59
     *@Description: 限制上传图片的类型
     */
    editor.config.uploadImgAccept = then.imgDefaultType;

    /*
     *@Author: czc
     *@Date: 2021-07-12 14:18:29
     *@Description: 限制一次可以上传几张图片
     */
    // editor.config.uploadImgMaxLength = then.imgMaxLength;

    /*
     *@Author: czc
     *@Date: 2021-07-12 15:14:39
     *@Description: 隐藏插入网络图片的功能
     */
    editor.config.showLinkImg = false;

    /*
     *@Author: czc
     *@Date: 2021-07-12 14:25:03
     *@Description: 自定义上传图片
     */
    editor.config.customUploadImg = (resultFiles, insertImgFn) => {
      /**
       * resultFiles：图片上传文件流
       * insertImgFn：插入图片到富文本
       * 返回结果为生成的图片URL地址
       *  */
      // 调用文件上传方法
      console.log('resultFiles',resultFiles)
      for(var i = 0;i < resultFiles.length;i++){
          then.wwdUploadImg(resultFiles[i]).then((url) => {
            !!url && insertImgFn(url);
          });
      }
     
    };
    // 忽略粘贴内容中的图片
    // editor.config.pasteIgnoreImg = false;

    /*
     *@Author: czc
     *@Date: 2021-07-12 14:22:55
     *@Description: 自定义报错方式
     */
    editor.config.customAlert = (err) => {
      then.$message.error(err);
    };

    /*
     *@Author: czc
     *@Date: 2021-07-12 14:03:01
     *@Description: 自定义配置参数并合并
     */
    Object.assign(editor.config, then.receiveConfig);

    // 创建编辑器
    editor.create();

    this.editor = editor;
  },
  beforeDestroy() {
    // 调用销毁 API 对当前编辑器实例进行销毁
    this.editor.destroy();
    this.editor = null;
  },
  methods: {
    getEditorData() {
      // 通过代码获取编辑器内容
      let data = this.editor.txt.html();
      alert(data);
    },
    // 清空当前内容
    clearEditorData() {
      this.editor.txt.clear();
    },
    // 禁用编辑器
    editDisable() {
      this.editor.disable();
    },
    // 禁用编辑器后重新启用编辑器
    editReuse() {
      this.editor.enable();
    },
    // 维旺迪项目图片上传方法（此功能待扩展）
    wwdUploadImg(file) {
      return new Promise((resolve, reject) => {
        const then = this;
        let fd = new FormData();
          fd.append("file", file);
          fd.append("type", then.fileType);
          then
            .axios({
              timeout: 900000,
              hostUrl: this.zuul,
              url: "/xyj-admin/w/FileUploadController/uploadFileType",
              method: "post",
              data: fd,
            })
            .then((res) => {
              resolve(res);
            })
            .catch((err) => {
              then.$message.error(err.message);
              reject();
            });
      });
    },
  },
};
</script>

<style scoped lang="scss">
.editor {
  width: 100%;
  margin: auto;
  position: relative;
  .btn {
    position: absolute;
    right: 0;
    top: 0;
    padding: 5px 10px;
    cursor: pointer;
  }
  h3 {
    margin: 30px 0 15px;
  }
  // 维旺迪客户要求高度自适应 该插件目前只能直接修改css
  /deep/ .w-e-text-container {
    // height: auto !important; /*!important是重点，因为原div是行内样式设置的高度300px*/
    min-height: calc(100vh - 390px) !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/xyjCustomWangEditor/customWangEditor.vue